import $ from 'jquery'
import { useSelect, dispatch } from '@wordpress/data';
const bookingStoreName = 'WPTravelFrontend/BookingData';
import { useEffect, useState } from '@wordpress/element'

export default () => {
    const [ buttonRequest, setRequest ] = useState(true);
    const [ stCardError, setStCardErro ] = useState({ card : '' })
    const [ paymentSuccess, setPaymentSuccess ] = useState(false)
    const bookingData  = useSelect((select) => { return select(bookingStoreName).getAllStore() }, []);
    const { updateStore } = dispatch( bookingStoreName );
    const { checkoutDetails, price_list, currency_code } = bookingData;
    const { trip_price, partial_amount } = price_list
    const { booking_selected  } = checkoutDetails;
    const { wp_travel_booking_option } = typeof booking_selected != 'undefined' && booking_selected || "booking_only";
    const { wp_travel_payment_mode } = typeof booking_selected != 'undefined' && booking_selected || "partial";
    const payments = {
        paypal: function() {
            jQuery("#wp-travel-book-now, #wp-travel-complete-partial-payment").show().siblings().hide();
            jQuery(".paypal-button").remove();
        }
    };
    useEffect( () => { 
        var z = wp_travel.express_checkout;
        if (typeof payments !== 'undefined') {
            const express_checkout_onpage = () =>  {
                if ( typeof z !== void 0 ) {
                    var complete = function(l) {

                        var form_id = 'wp-travel-booking'; // Default payment form id

                        var payment_form_id = $( '#wp-travel-payment-form-id' ).val();

                        if ( payment_form_id ) {
                            form_id = payment_form_id;
                        }

                        $('.loader-active').show();
                        
                        $( '[name=payment_details]' ).remove();
                        $( 'form#' + form_id ).append($("<input type='hidden' name='payment_details' />").attr( "value", JSON.stringify(l) ) ).find("[type=submit]").click();
                        
                    };

                    var a = $("#wp-travel-booking"),
                        b = 0 < a.length && a.parsley(),
                        c = function(d) {
                            if (b && b.isValid) {
                                if (b.isValid()) return void d.enable();
                                d.disable()
                            } else d.enable()
                        };

                    ( "sandbox" == z.env && "" == z.sandbox_client_id || "production" == z.env && "" == z.production_client_id)
                    && $("input[value=express_checkout]")
                        .attr("disabled", "disabled")
                        .parent().append("<span class='client-not-found'> (Client ID not found).</span>"),
                    typeof payments !== void 0 
                    && (payments.express_checkout = function() {

                        $("#wp-travel-book-now, #wp-travel-complete-partial-payment").hide().siblings().hide();
                        $(".paypal-button").remove();
                        var d = {
                            size: z.size || "medium",
                            shape: z.shape || "pill",
                            color: "credit" === z.label ? void 0 : z.color || "gold",
                            layout: z.allow_card == 'on' ? 'vertical' : "horizontal"
                        };

                        if (z.allow_card == 'on' && z.size == 'small') {
                            d.size = 'medium';
                        }

                        "vertical" != z.layout && (d.label = z.allow_card == 'on' ? undefined : z.label || 'pay');
                        var e = [];
                        "on" == z.card_option && e.push(paypal.FUNDING.CARD), "on" == z.credit_option && e.push(paypal.FUNDING.CREDIT), "on" == z.elv_option && e.push(paypal.FUNDING.ELV);
                        var g = z.env || "sandbox",
                            h = z.locale || "en_US",
                            i = {
                                sandbox: z.sandbox_client_id,
                                production: z.production_client_id
                            };
                        try {
                            var form_id = 'wp-travel-booking'; // Default payment form id

                            var payment_form_id = $( '#wp-travel-payment-form-id' ).val();

                            if ( payment_form_id ) {
                                form_id = payment_form_id;
                            }
                            paypal.Button.render({
                                env: g,
                                commit: !0,
                                locale: h,
                                style: d,
                                client: i,
                                validate: function(j) {
                                    $(".fa-validated-now").fadeOut();
                                    c(j);
                                    $(document).on("change keyup", "form#"+ form_id +" input", function() {
                                        c(j)
                                    })
                                },
                                funding: {
                                    allowed: e
                                },
                                onClick: function onClick() {
                                    b && b.validate()
                                },
                                payment: function(j, k) {
                                    var l = $("#wp-travel-payment-mode option:selected").val(),
                                    m = $(".entry-title").html() || "Trip Book",
                                    n = $("#overview").find("p").html() || "Trip Description",
                                    // o = "partial" == l ? wp_travel.payment.payment_amount : wp_travel.payment.trip_price,
                                    p = 1;
                                    var o = l ==  'partial' ? partial_amount : trip_price;
                                    return  (o *= parseInt(p)), k.payment.create({
                                        payment: {
                                            transactions: [{
                                                amount: {
                                                    total: o,
                                                    currency: typeof currency_code != 'undefined' ? currency_code : "USD"
                                                },
                                                item_list: {
                                                    items: [{
                                                        name: m,
                                                        description: n,
                                                        quantity: 1,
                                                        price: o,
                                                        currency: typeof currency_code != 'undefined' ? currency_code : "USD"
                                                    }]
                                                }
                                            }]
                                        }
                                    })
                                },
                                onAuthorize: function(j, k) {
                                    return k.payment.execute().then(complete)
                                },
                                onCancel: function() {
                                    alert("You canceled the payment.")
                                },
                                onError: function(e) {
                                   var msg = "We could not process your payment. Please try again.";
                                    alert( msg)
                                }
                            }, "#" + form_id + " .wp-travel-form-field.button-field")
                        } catch (j) {}
                        // $(".paypal-button").after("<i style='margin-top:12px; margin-left:10px;' class='fa-validated-now fa fa-spin fa-spinner'></i>")
                    },

                    "express_checkout" == $("[name=wp_travel_payment_gateway]:checked").val() && payments.express_checkout())
                }
            }
           

            $('input[name="wp_travel_payment_gateway"]').on('change', function () {

                if(  $(this).val() == 'express_checkout' ){
                    express_checkout_onpage();
                }
                
            });
        }                                                                                           
    }, [ wp_travel_booking_option, trip_price, wp_travel_payment_mode ])
    return <>
        <div className='wp-travel-one-page-booking-buttons' > 
            <input type="submit" name="wp_travel_book_now" id="wp-travel-book-now" value="Book Now" /> 
        </div> 
    </>
}